var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "g-resize-bar" }, [
    _c("div", {
      staticClass: "g-resize-highlight",
      style: { width: _vm.left + "%" }
    }),
    _vm._v(" "),
    _c("button", {
      staticClass: "circle-btn",
      style: { left: _vm.left + "%" },
      on: {
        touchstart: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.drag.apply(null, arguments)
        },
        mousedown: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.drag.apply(null, arguments)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024d0321", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024d0321","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-core-image-upload/src/resize-bar.vue
// module id = 1700
// module chunks = 0